import { makeStyles, Tooltip } from "@material-ui/core";
import React from "react";
import { ALPHABET } from "../../function/select_function";
import CloseIcon from '@mui/icons-material/Close';
import $ from 'jquery';
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    itemsWrapper: {
      display: "flex",
      alignIems: "center",
      position: "relative"
    }
  }));

export const DefaultSelect = ({ ...props }) => {
    const [checked,setChecked] = React.useState({})
    const classes = useStyles();
    const { show_shortcuts, type_shortcuts } = useSelector((state) => ({
      show_shortcuts: state['theme_config'].show_shortcuts,
      type_shortcuts: state['theme_config'].type_shortcuts
    }));
    const styleCheck = show_shortcuts === '1' ? {borderRadius :'unset'} : props.typeSelect === 'SELECT_ONE' ? {borderRadius:'50%'} : {borderRadius:'unset'}
    return (
      <div style={{ width: "fit-content", paddingTop: "15px" }}>
        {props.choicesListNew[props.choice]?.map((choice, index) => {
          return (
            <div 
                key ={`${props.choice}_${choice.name}_key`} 
                className={classes.itemsWrapper}
                onMouseOver={()=>{
                    $(`#${props.choice}_${choice.name}_dlt_btn`).css("opacity","1")
                }}
                onMouseOut={()=>{
                    $(`#${props.choice}_${choice.name}_dlt_btn`).css("opacity","0")
                }}
              >
              <Tooltip 
                title={(!props.previewForm && (props.previewForm || props.collector.Choice === "TRUE") && window.ListNameDefault.indexOf(props.choice) === -1)? "Double click to edit" :""}
                placement="bottom"
              >
                <div
                  className="tf-select"
                  style={
                    checked?.[choice.name] ?
                    {
                      boxShadow: "var(--answer-color) 0px 0px 0px 2px inset"
                    } :
                    {
                      boxShadow: "var(--answer-color-opacity) 0px 0px 0px 1px inset"  
                    }
                  }
                  onClick = {(e)=>{
                    if(checked?.[choice.name]){
                      setChecked({[choice.name] : false})
                    }else{
                      setChecked({[choice.name] : true})
                    }
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                  onDoubleClick={(e) => {
                    !props.previewForm && (props.previewForm ||
                      props.collector.XlsType !== "SINGLE_TEMPLATE") &&
                      window.ListNameDefault.indexOf(props.choice) === -1 &&
                      props.handleClickOpen(choice);
      
                      e.preventDefault()
                      e.stopPropagation()
                  }}
                >
                  <span 
                      className="hint-select"
                      style={
                        checked?.[choice.name] ?
                        {
                          color: "var(--background-color)",
                          backgroundColor: "var(--answer-color)",
                          ...styleCheck
                        } :
                        {
                          ...styleCheck
                        }
                      }
                    >
                      {show_shortcuts =='1' && (type_shortcuts =='text' ? ALPHABET[index] : index)}
                    </span>
                  
                  <label
                    className="m-0"
                    style={{
                      padding: "0 calc(var(--font-size-answer-select)/1.5",
                      cursor: "pointer",
                    }}
                  >
                    {choice["label::" + props.language]}
                  </label>
                </div>
              </Tooltip>
              {
                  !props.previewForm && (props.previewForm || props.collector.Choice === "TRUE") &&
                  window.ListNameDefault.indexOf(props.choice) === -1 && (
                      <lable
                          id={`${props.choice}_${choice.name}_dlt_btn`}
                          style={{right:"-5px"}}
                          className="m-0 dlt_choice_btn"
                          onClick={(e) => {
                              props.handleDeleteChoice(choice, props.choicesList);
                              e.preventDefault()
                              e.stopPropagation()
                          }}
                          >
                          <CloseIcon fontSize="small"/>
                      </lable>
                  )
              }
            </div>
          );
        })}
      </div>
    );
  };